/* eslint-disable */
var recordText = ''
var recordTextIsFinal = false
var recordActived = false
var isStopedRecord = false

var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition || null

if (SpeechRecognition !== null) {
  var recognition = new webkitSpeechRecognition()

  recognition.onstart = function() { 
    // console.log('onstart')
    recordActived = true
  }
  recognition.onspeechend = function() {
    // console.log('onspeechend')
  }
  recognition.onend = function() {
    // console.log('onend')
    if (isStopedRecord) {
      recordActived = false
    } else {
      recognition.start()
    }
  }
  recognition.onerror = function(event) {
    // console.log('onerror')
    recordActived = 'error'
  }
  recognition.interimResults = true
  // continuous não funciona para o mobile
  // recognition.continuous = true
  recognition.onresult = function(event) {
    var current = event.resultIndex
    var result = event.results[current]
    recordText = result[0].transcript
    recordTextIsFinal = result.isFinal
    if (result.isFinal) {
      document.getElementById('isRecordRunning').checked = false
    }
  }
}
function getRecordtext () {
  return recordText
}
function setRecordtext (text) {
  recordText = text
}
function recordtextIsFinal () {
  return recordTextIsFinal
}
function isRecordActived () {
  return recordActived
}
function startRecord () {
  isStopedRecord = false
  recognition.start()
}
function stopRecord () {
  isStopedRecord = true
  recognition.stop()
}
function isRecordSuported () {
  return SpeechRecognition !== null
}

export {isRecordActived, getRecordtext, setRecordtext, recordtextIsFinal, startRecord, stopRecord, isRecordSuported}


// WEBPACK FOOTER //
// ./src/record.js